import { render } from "./SchoolBoardForm.vue?vue&type=template&id=2da8593b&scoped=true"
import script from "./SchoolBoardForm.vue?vue&type=script&lang=js"
export * from "./SchoolBoardForm.vue?vue&type=script&lang=js"

import "./SchoolBoardForm.vue?vue&type=style&index=0&id=2da8593b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da8593b"]])

export default __exports__